import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-5050',
  styleUrl: 'cradlepoint-5050.css',
  shadow: true,
})
export class Cradlepoint5050 {
  @Prop() image           : string;
  @Prop() imagePosition   : string;
  @Prop() backgroundColor : string;
  @Prop() height          : string = 'auto';

  render() {
    return (
      <cradlepoint-container
        background-color={this.backgroundColor}
        style={{
          minHeight: this.height
        }}
        columns='repeat(2, 1fr)'
      >
        <div class={`image-container ${(this.imagePosition == 'right') && this.imagePosition}`}>
          <img src={ this.image && this.image } />
        </div>
        <div class="content-container">
          <slot></slot>
        </div>
      </cradlepoint-container>
    );
  }

}
